const cleaningPass = [
  require('./cleaning-pass/use-replacer'),
  require('./cleaning-pass/viewbox-processor'),
  require('./cleaning-pass/unsupported-remover'),
  require('./cleaning-pass/grouper'),
  require('./cleaning-pass/style-converter'),
  require('./cleaning-pass/id-setter'),
  require('./cleaning-pass/def-text-remover'),
  require('./cleaning-pass/hidden-remover'),
  require('./cleaning-pass/unit-converter'),
  require('./cleaning-pass/recalculate'),
  require('./cleaning-pass/duplicate-path-remover'),
  require('./cleaning-pass/empty-group-remover'),
  require('./cleaning-pass/text-add-subelement')
];

module.exports = function (content, options) {
  if (!content) return;

  const sticker = $.parseXML(content.replace(/\s+/g, ' '));
  let svg = sticker.getElementsByTagName('svg')[0];

  options = options || {};

  svg && _.any(cleaningPass, function (pass) {
    svg = pass(svg, content, options);
    return !svg;
  });

  if (!svg || !svg.childNodes.length) {
    return;
  }

  return svg;
};
